import { observable, action, computed, flow, toJS } from 'mobx';
import Stores from 'config/Stores';
import { Toast } from 'antd-mobile';
import dayjs from 'dayjs';
import Serv from './NewAddServ';

class NewAddMod {
  // 任务id和subId, 编辑日程时用到
  @observable id = '';

  @observable subId = '';

  // 任务状态，编辑日程时用到
  @observable status = '';

  // 任务内容
  @observable content = '';

  // 开始时间、结束时间
  @observable startTime = '';

  @observable endTime = '';

  @observable customers = [];

  // 提醒时间(默认开始前5分钟)、提醒方式(1-站内信)
  @observable remindTime = 2;

  @observable remindWay = 1;

  // 地址、重复方式、备注
  @observable address = '';

  @observable repeat = 0;

  @observable extra = '';

  // 节流（创建按钮）
  @observable creating = false;

  /**
   * 修改参数逻辑
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @action
  clearData() {
    this.id = '';
    this.subId = '';
    this.status = '';
    this.content = '';
    this.startTime = '';
    this.endTime = '';
    this.customers = [];
    this.remindTime = 2;
    this.remindWay = 1;
    this.address = '';
    this.repeat = 0;
    this.extra = '';
  }

  /**
   * 获取客户列表
   */
  getCustomerList = flow(function* () {
    try {
      const { data } = yield Serv.getCustomerList({
        memberId: Stores.AppMod.userInfo.id
      });
    } catch (error) {}
  });

  /**
   * 获取任务详情
   */
  getDetail = flow(function* (params) {
    const { data } = yield Serv.getDetail(params);
    this.status = data.status;
    this.content = data.content;
    this.startTime = data.startTime;
    this.endTime = data.endTime;
    this.customers = data.customerDtos || [];
    this.remindTime = data.remindTimeType;
    this.remindWay = data.remindType;
    this.address = data.address;
    this.repeat = data.repetitionType;
    this.extra = data.remark;
  });

  /**
   * 新建/更新日程
   */
  updateTask = flow(function* () {
    if (
      !this.content ||
      !this.startTime ||
      !this.endTime ||
      this.repeat == -1 ||
      this.remindWay == -1 ||
      this.remindTime == -1
    ) {
      Toast.fail('信息填写不全，请继续完善', 1);
      return;
    }
    if (this.creating) return;
    this.creating = true;
    let customers = toJS(this.customers);
    let index = customers.findIndex((item) => item.customerId == Stores.AppMod.userInfo.id);
    console.log(2223344, index);
    if (index >= 0) customers.splice(index, 1);
    try {
      let params = {
        address: this.address,
        content: this.content,
        startTime: this.startTime,
        endTime: this.endTime,
        remindTimeType: this.remindTime,
        remindType: 1 || this.remindWay, // 先写死为1
        remindCustomerType: 0,
        customerDtos: customers,
        repetitionType: this.repeat,
        remark: this.extra,
        status: 2,
        channelType: 2
      };
      if (this.id) {
        params.id = this.id;
        params.subId = this.subId;
        params.status = this.status;
      }
      yield Serv.updateTask(params);
      this.creating = false;
      Toast.success(this.id ? '修改成功！' : '创建成功！', 1, () => {
        this.id ? window.app.router.goBack(-2) : window.app.router.goBack();
        this.clearData();
      });
    } catch (error) {
      this.creating = false;
    }
  });

  /**
   * 任务时间
   */
  @computed
  get taskTimeText() {
    return this.startTime && this.endTime
      ? `${dayjs(this.startTime.replace(/-/g, '/')).format('YYYY-MM-DD HH:mm')} ~ ${dayjs(
          this.endTime.replace(/-/g, '/')
        ).format('YYYY-MM-DD HH:mm')}`
      : '';
  }

  /**
   * 提醒客户
   */
  @computed
  get remindCustomerText() {
    const { userInfo } = Stores.AppMod;
    if (!this.customers.length) return `${userInfo.realName}共1人`;
    let textList = [];
    this.customers.forEach((item) => {
      textList.push(item.customerName);
    });
    return `${textList.join('、')}共${this.customers.length}人`;
  }

  /**
   * 提醒时间
   */
  @computed
  get remindTimeText() {
    const remindTimeMap = {
      0: '无',
      1: '日程开始时',
      2: '5分钟前',
      3: '15分钟前',
      4: '30分钟前',
      5: '1小时前',
      6: '2小时前',
      7: '1天前',
      8: '2天前',
      9: '1周前'
    };
    return remindTimeMap[this.remindTime] || '';
  }

  /**
   * 重复
   */
  @computed
  get repeatText() {
    const repeatMap = {
      0: '不重复',
      1: '每个工作日',
      2: '每天',
      3: '每周',
      4: '每月',
      5: '每年'
    };
    return repeatMap[this.repeat] || '';
  }
}

const newAddMod = new NewAddMod();
export default newAddMod;



// WEBPACK FOOTER //
// ./src/pages/Promote/Schedule/NewAdd/NewAddMod.js